/**
 * Cockpit — vue principale du Bureau quand un master est sélectionné.
 * Affiche les 4 cartes outils (Drive · Calendar · Docs · Keep).
 *
 * Extrait de Bureau.jsx (Batch #14.221).
 */
import { Loader2, AlertTriangle, Power } from "lucide-react";
import DriveToolCard from "./DriveToolCard";
import CalendarToolCard from "./CalendarToolCard";
import KeepToolCard from "./KeepToolCard";
import DocsHubCard from "../masters/DocsHubCard";

export default function Cockpit({ master, activeExp, setActiveExp, expertiseTabs, hub, busy, onCreateCalendar }) {
  // Batch #14.23 — Si aucune expertise activée, bandeau ambre pointant vers la fiche client
  if (expertiseTabs.length === 0) {
    return (
      <div className="bg-amber-50 border border-amber-200 rounded-2xl p-6 text-center" data-testid="bureau-no-expertise">
        <AlertTriangle className="w-7 h-7 text-amber-500 mx-auto mb-2" />
        <h2 className="font-semibold text-amber-900">Aucune expertise activée</h2>
        <p className="text-sm text-amber-800 mt-1 mb-4">
          Pour débloquer le Bureau de ce dossier, activez au moins une expertise (Fiscal, Immeuble, Paie ou Tenue de livres).<br />
          Cela se fait depuis la fiche client.
        </p>
        <a
          href={`/admin/base-fiscale/${master.id}`}
          className="inline-flex items-center gap-2 px-4 py-2 rounded-lg bg-amber-600 text-white text-sm font-semibold hover:bg-amber-700"
          data-testid="bureau-open-master-btn"
        >
          <Power className="w-4 h-4" /> Ouvrir la fiche client pour activer
        </a>
      </div>
    );
  }

  return (
    <div className="bg-white border border-slate-200 rounded-2xl p-5 shadow-sm">
      {/* Onglets expertises */}
      <div className="flex items-center gap-1 border-b border-slate-200 mb-5">
        {expertiseTabs.map((t) => {
          const active = activeExp === t.id;
          const Icon = t.icon;
          return (
            <button
              key={t.id}
              onClick={() => setActiveExp(t.id)}
              className={`px-4 py-2.5 text-sm inline-flex items-center gap-2 border-b-2 transition ${
                active ? "border-indigo-600 text-indigo-700 font-semibold" : "border-transparent text-slate-500 hover:text-slate-700"
              }`}
              data-testid={`bureau-tab-${t.id}`}
            >
              <Icon className="w-4 h-4" /> {t.label}
            </button>
          );
        })}
      </div>

      {/* 4 cartes outils */}
      {!hub ? (
        <Loader2 className="w-5 h-5 animate-spin text-slate-400 mx-auto" />
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
          <DriveToolCard
            hub={hub}
            masterId={master.id}
            expertise={activeExp}
            onLinked={() => { window.location.reload(); }}
          />
          <CalendarToolCard
            hub={hub}
            busy={busy}
            onCreate={onCreateCalendar}
            masterId={master.id}
            expertise={activeExp}
            onLinked={() => { window.location.reload(); }}
          />
          <DocsHubCard
            masterId={master.id}
            expertise={activeExp}
            expertiseActivated={true}
            manualUrl={hub.docs?.manual_url}
            onLinked={() => { window.location.reload(); }}
          />
          <KeepToolCard
            hub={hub}
            masterId={master.id}
            expertise={activeExp}
            onLinked={() => { window.location.reload(); }}
          />
        </div>
      )}
    </div>
  );
}
